export default {
  cupons: [],
  pagination: {},
  cupon: {}
}
